/* global $ */

/**
 * knowledgeable 換圖
 */
$('.knowList').click((e) => {
  e.preventDefault();

  /**
   * toggle image opacity
   */
  if (e.target.tagName === 'A') {
    $('#know-image div').css('opacity', 0);
    const clickValue = e.target.dataset.image;
    $(`.${clickValue}-images`).css('opacity', 1);
  }
});

function api(method, src, args, token, callback) {
	let req = new XMLHttpRequest();
	if(method.toLowerCase() === "post"){
		req.open(method, src);
		req.setRequestHeader("Content-Type", "application/json");
		if (token) {
			req.setRequestHeader('Authorization', 'Bearer ' + token);
		}
		req.onload = callback;
		req.send(JSON.stringify(args));
	}else{
		req.open(method, src + "?" + args);
		req.setRequestHeader("Content-Type", "application/json");
		if (token) {
			req.setRequestHeader('Authorization', 'Bearer ' + token);
		}
		req.onload = callback;
		req.send();
	}
}

function getBlogList() {
	const accessToken = '';
	api('get', 'https://fable.com.tw/api/blog/medium/list/all', '', accessToken, function() {
		let data = JSON.parse(this.responseText);
		if(!data){
			dataErr();
		}else{
			let digitalTab = document.getElementById('digitalList');
			let pmTab = document.getElementById('pmList');
			let insightTab = document.getElementById('insightList');
			let teamTab = document.getElementById('teamList');
			let riskTab = document.getElementById('riskList');
			if (data.data.length > 5) {
				for (let i = 0; i <= 5; i++) {
					let newItem =  `<li class="blog-list"><a href="https://fable.com.tw/post/medium/${data.data[i].id}" target="_blank">${data.data[i].title}</a></li>`;
					digitalTab.innerHTML = digitalTab.innerHTML + newItem;
					pmTab.innerHTML = pmTab.innerHTML + newItem;
					insightTab.innerHTML = insightTab.innerHTML + newItem;
					teamTab.innerHTML = teamTab.innerHTML + newItem;
					riskTab.innerHTML = riskTab.innerHTML + newItem;
				}
				digitalTab.innerHTML = digitalTab.innerHTML + `<li><a href="#">...</a></li>`;
			} else {
				for (let i = 0; i < data.data.length; i++) {
					let newItem =  `<li class="blog-list"><a href="https://fable.com.tw/post/medium/${data.data[i].id}" target="_blank">${data.data[i].title}</a></li>`;
					digitalTab.innerHTML = digitalTab.innerHTML + newItem;
					pmTab.innerHTML = pmTab.innerHTML + newItem;
					insightTab.innerHTML = insightTab.innerHTML + newItem;
					teamTab.innerHTML = teamTab.innerHTML + newItem;
					riskTab.innerHTML = riskTab.innerHTML + newItem;
				}
			}
		}
	});
}

window.addEventListener('load', function () {
	getBlogList();
})